<template>
    <table class="table table-striped table-hover" v-if="specifications">
        <thead>
            <tr class="d-flex">
                <th class="col-8 col-sm-6 col-md-4 col-lg-4"><i style="margin-right:15px;"></i>Namn</th>
                <th class="col-4 col-sm-3 col-md-3 col-lg-2 d-none d-sm-block">Datum</th>
                <th class="col-0 col-lg-2 d-none d-lg-block">Version</th>
                <th class="col-0 col-lg-2 d-none d-md-block">Status</th>
                <th class="col-0 col-sm-3 col-md-2 col-lg-2">Lönesumma</th>
            </tr>
        </thead>
        <tbody>
            <tr
                class="d-flex"
                v-bind:class="{'table-danger': specification.isDeprecated }"
                v-for="specification in specifications"
                :key="specification.id"
                v-on:click="salarySpecificationSelect(specification)"
                style="cursor:pointer;z-index:10">
                <td class="col-8 col-sm-6 col-md-4 col-lg-4">
                    <i class="fa fa-plus-square-o mr-1" v-if="!specification.isDeprecated && specification.version > 1 && !specification.showVersions" 
                        v-on:click.stop="showVersions(specification)"></i>
                    <i class="fa fa-minus-square-o mr-1" v-if="specification.showVersions && !specification.isDeprecated && specification.version > 1" 
                        v-on:click.stop="hideVersions(specification)"></i>
                    <i style="margin-right:17px" v-if="specification.version === 1 || (!specification.showVersions && specification.isDeprecated)"></i>{{specification.user.firstName}} {{specification.user.lastName}}</td>
                <td class="col-4 col-sm-3 col-md-3 col-lg-2 d-none d-sm-block">{{specification.paymentDate | moment("YYYY-MM-DD") }}</td>
                <td class="col-0 col-lg-2 d-none d-lg-block">{{specification.version}}</td>
                <td class="col-0 col-lg-2 d-none d-md-block">{{specificationStatus(specification)}}</td>
                <td class="col-0 col-sm-3 col-md-2 col-lg-2">{{specification.netSalary | currency}}</td>
            </tr>
        </tbody>
        <tfoot v-if="specifications && specifications.length > 0">
            <tr class="d-flex">
                <td class="col-8 col-sm-6 col-md-4 col-lg-4"></td>
                <td class="col-4 col-sm-3 col-md-3 col-lg-2 d-none d-sm-block"></td>
                <td class="col-0 col-lg-2 d-none d-lg-block"></td>
                <td class="col-0 col-lg-2 d-none d-md-block"></td>
                <td class="col-0 col-sm-3 col-md-2 col-lg-2"><strong>{{totalSalary | currency}}</strong></td>
            </tr>
        </tfoot>        
 
        <tfoot v-if="!specifications || specifications.length === 0">
            <tr>
                <td colspan="5">Inga lönespecifikationer existerar för perioden</td>
            </tr>
        </tfoot>
    </table>    
</template>

<script>
import { salarySpecificationService } from "../../../shared/services";

export default {
    computed: {
        totalSalary() {
            var sum = 0;
            this.specifications.filter(p => !p.isDeprecated).forEach(p => sum += p.netSalary);
            return sum;
        },
    },
    props: ["salarySpecifications", "keyId"],
    watch: {
        salarySpecifications: function(newVal, oldVal) {
            this.specifications = newVal.map(p => this.mapSpecification(p));
        }
    },
    methods:{
        specificationStatus(specification) {
            if (specification.isDeprecated) return "Deprekerad";
            if (specification.isAttested) return "Attesterad";
            if (specification.isLocked) return "Låst";
            return "Utkast";
        },
        salarySpecificationSelect(specification) {
            this.$emit("onSalarySpecificationSelected", specification);
        },
        showVersions(salarySpecification) {
            salarySpecification.showVersions = true;
            this.$emit("onLoading", true);
            var moment = this.$moment(salarySpecification.paymentDate);
            salarySpecificationService.getVersions(salarySpecification.user.id, moment.year(), moment.month() + 1).then(p => {
                            this.$emit("onLoading", false);
                            var position = this.specifications.indexOf(salarySpecification) + 1;
                            var versions = p.filter(v => v.isDeprecated);

                            versions.forEach(c => {
                                this.specifications.splice(position, 0, this.mapSpecification(c, salarySpecification));
                                position++;
                            });
                        }).catch(() => 
                        {
                            this.$emit("onLoading", false);
                            this.ShowToast("Fel", "Ett okänt fel uppstod då versioner för lönespecifikation skulle hämtas", "danger")
                        });
        },
        hideVersions(salarySpecification) {
            salarySpecification.showVersions = false;
            var deprecatedVersions = this.specifications.filter(v => v.parentSpecification == salarySpecification);
            deprecatedVersions.forEach(v => {
                var position = this.specifications.indexOf(v);
                this.specifications.splice(position, 1);
            });
        },
        mapSpecification(specification, parentSpecification) {
            return {
                showVersions: false,
                id:specification.id,
                version: specification.version,
                user: specification.user,
                paymentDate: specification.paymentDate,
                isAttested: specification.isAttested,
                isLocked: specification.isLocked,
                isDeprecated: specification.isDeprecated,
                netSalary: specification.netSalary,
                parentSpecification: parentSpecification,
            }
        }
    },
    data() {
        return {
            specifications: []
        };
    },

}
</script>

<style>

</style>
